import includes from "lodash/includes";
export const isLocalHosted = includes(window.location.hostname, "localhost");
export const imageURl = isLocalHosted ? `${window.location.origin}/static/img` : `${window.location.origin}/static/img`
export const AudioUrl = isLocalHosted ? `${window.location.origin}/static/audio` : `${window.location.origin}/static/audio`
export const isStaging = includes(window.location.hostname, "gradingly.netlify.app");
export const SpeakUrl = "/speak/";
export const EXAMLAB_URL = "/elab/";
export const MaterialUrl = "/material/";
export const CustomMaterialUrl = "/material/generate/custom" ;
export const GenMaterialUrl = "/material/generate" ;
export const EditMaterialUrl = "/material/edit" ;
export const MTempUrl = "/material/template/";
export const GenaiUrl = "/edit-exercise/" ;
export const TempUrl = "/preview-template/" ;
export const CreateQuizUrl = "/generate" ;
export const isQuizydev = includes(window.location.origin, "eltcloud-dev");
export const QuizyUrl = isQuizydev ? "eltcloud-dev" : "quizy";
let params = new URL(document.location).searchParams;
export const redirect_back = params.get("redirect") ;
export const isNoviumProd = includes(window.location.origin, "prosperity");
export const isNovium = isNoviumProd ? "app.prosperityenglish" : "noviumtest";
export const isEuroProd = includes(window.location.origin, "dilats");
export const isEuro = isEuroProd ? "dilats" : "eurolingva" ;
export const isExamLab = "examlab" ;
export const isB2B = [isNovium,isEuro];
export const isB2C = ["b2c","prosperity",isNovium,isEuro];
export const isSPEAKABC =  includes(window.location.origin, "speakabc");
export const websocketUrl = isLocalHosted
  ? `ws://${window.location.host}/ws/mywebsocket/`
  : `wss://${window.location.host}/ws/mywebsocket/`;
export const MaterialwebsocketUrl = isLocalHosted
  ? `ws://${window.location.host}/ws/materialwebsocket/`
  : `wss://${window.location.host}/ws/materialwebsocket/`;
export const baseUrl = isLocalHosted
  ? `${window.location.origin}`
  : `${window.location.origin}`;

export const baseStagingAPI = `${baseUrl}/api`;

export const getBaseApiUrl = () => baseStagingAPI;
